export var DefaultsColumns = function (t) { return [
    {
        caption: t('Entity'),
        field: 'entity',
        cellType: 'string',
        width: 'auto',
    },
    {
        caption: t('Updated field/item'),
        field: 'identifier',
        cellType: 'custom',
        alignment: 'left',
        width: 'auto',
    },
    {
        caption: t('Original Value'),
        field: 'origin',
        cellType: 'custom',
    },
    {
        caption: t('New Value'),
        field: 'diff',
        cellType: 'custom',
    },
    {
        caption: t('Updated By'),
        field: 'author',
        cellType: 'custom',
        width: 'auto',
    },
    {
        caption: t('Modify Date'),
        field: 'datetime',
        cellType: 'date',
        alignment: 'right',
        width: 'auto',
    },
]; };
export var DefaultFilters = function (t) { return [
    {
        label: 'Section',
        field: 'entity',
        type: 'select',
        defaultValue: 'locationgroup',
        options: [
            {
                label: 'Location Groups',
                value: 'locationgroup',
            },
            {
                label: 'Roles',
                value: 'role',
            },
            {
                label: 'Users',
                value: 'profile',
            },
            {
                label: 'Applications',
                value: 'mispapp',
            },
        ],
    },
    {
        label: t('From'),
        field: 'from',
        type: 'date',
        hashParam: 'date-from',
        disableFutureDates: true,
    },
    {
        label: t('To'),
        field: 'to',
        type: 'date',
        hashParam: 'date-to',
        disableFutureDates: true,
    },
]; };
export var metadataDefaultsMap = {
    'YES_NO': [],
    'ACTIVE_INACTIVE': ['Active', 'Inactive'],
    'ON_OFF': ['On', 'Off'],
};
export var metadataDefaultsMapGenerator = function (generator, defaultMetadata) {
    return generator.apply(void 0, metadataDefaultsMap[defaultMetadata]);
};
//# sourceMappingURL=defaults.js.map